export const LTC = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#3566C5" />
    <path
      d="M15.4426 20.0491L16.3797 16.5551L18.5985 15.7525L19.1504 13.6992L19.1316 13.6482L16.9475 14.4382L18.5211 8.57153H14.0583L12.0003 16.2277L10.2821 16.8492L9.71436 18.9661L11.4313 18.3451L10.2184 22.8572H22.0958L22.8572 20.0491H15.4426Z"
      fill="white"
    />
  </svg>
);
